/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductHistoryItem
 */
export interface ProductHistoryItem {
    /**
     * Timestamp of change (CEST)
     * @type {Date}
     * @memberof ProductHistoryItem
     */
    dateTime: Date;
    /**
     * Full name with U number (e.g. Maria del Pilar (u57683))
     * @type {string}
     * @memberof ProductHistoryItem
     */
    modifiedBy: string;
    /**
     * Changed field label shown in product history. Supported values currently include Product status, Partner, and for Safe Deposit Box: Safe location, Safe number, Safe size, Key deposit at safe location and Signature authority.
     * @type {string}
     * @memberof ProductHistoryItem
     */
    attribute: string;
    /**
     * Previous value for the changed attribute
     * @type {string}
     * @memberof ProductHistoryItem
     */
    previousValue: string;
    /**
     * New value for the changed attribute
     * @type {string}
     * @memberof ProductHistoryItem
     */
    newValue: string;
}

/**
 * Check if a given object implements the ProductHistoryItem interface.
 */
export function instanceOfProductHistoryItem(value: object): value is ProductHistoryItem {
    if (!('dateTime' in value) || value['dateTime'] === undefined) return false;
    if (!('modifiedBy' in value) || value['modifiedBy'] === undefined) return false;
    if (!('attribute' in value) || value['attribute'] === undefined) return false;
    if (!('previousValue' in value) || value['previousValue'] === undefined) return false;
    if (!('newValue' in value) || value['newValue'] === undefined) return false;
    return true;
}

export function ProductHistoryItemFromJSON(json: any): ProductHistoryItem {
    return ProductHistoryItemFromJSONTyped(json, false);
}

export function ProductHistoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductHistoryItem {
    if (json == null) {
        return json;
    }
    return {
        
        'dateTime': (new Date(json['dateTime'])),
        'modifiedBy': json['modifiedBy'],
        'attribute': json['attribute'],
        'previousValue': json['previousValue'],
        'newValue': json['newValue'],
    };
}

export function ProductHistoryItemToJSON(json: any): ProductHistoryItem {
    return ProductHistoryItemToJSONTyped(json, false);
}

export function ProductHistoryItemToJSONTyped(value?: ProductHistoryItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dateTime': value['dateTime'].toISOString(),
        'modifiedBy': value['modifiedBy'],
        'attribute': value['attribute'],
        'previousValue': value['previousValue'],
        'newValue': value['newValue'],
    };
}

